import { render, staticRenderFns } from "./registrati.vue?vue&type=template&id=5bfbb1e0"
import script from "./registrati.vue?vue&type=script&lang=js"
export * from "./registrati.vue?vue&type=script&lang=js"
import style0 from "./registrati.vue?vue&type=style&index=0&id=5bfbb1e0&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports